import Seo from "@components/seo"
import AllTheScripts from "@components/all-the-scripts"

export const Head = (props) => {
  const { data, children } = props
  const page = data?.page
  const image = page?.socialImage ? page.socialImage.file.url : null

  if (typeof window !== "undefined" && "intellimize" in window && "activate" in window.intellimize) {
    // eslint-disable-next-line no-undef
    intellimize.ready(() => {
      // eslint-disable-next-line no-undef
      intellimize.activate()
    })
  }

  return (
    <>
      <Seo title={page?.socialTitle} description={page?.socialDescription} socialImage={image} />
      <AllTheScripts />
      {children}
    </>
  )
}

export const paginateTitles = (basePath, currentPage) => {
  if (currentPage === 1) return basePath
  return `${basePath} - ${currentPage}`
}
